import React, { Component } from 'react';
import { Card, CardText,CardTitle,CardDeck, Button } from 'reactstrap';
import item from './SubModuleDetail';

class SubModuleItem extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (event){

    switch(event.target.value) {
      case 'CCM':
        return window.location.hash = "#/";;
      default:
        return 'foo';
    }

  }

  render () {
    let {name, description,id} = this.props.module;

    const sunModuleItem = item[id].button.map((item, index) => ( 
      <Button color="warning" style={{marginLeft:"1%",marginRight:"2%",borderColor:"black"}} size="md" key={index}   onClick={this.handleClick} value={item} >{item}</Button>           
        ))
 
    return (
      <div>
        <Card style={{color:'black',borderRadius: 8}}>    
            <CardTitle>{name}</CardTitle>
            <CardText>{description}</CardText>
            <CardDeck>            
             {sunModuleItem}
          </CardDeck>    
        </Card>
      </div>
    )
}
}

export default SubModuleItem;
